var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_13","data-name":"Ellipse 13","cx":"24","cy":"24","r":"24","fill":"#e62a2c","key":0}),React.createElement("path",{"id":"Icon_awesome-linkedin-in","data-name":"Icon awesome-linkedin-in","d":"M5.53,24.7H.408V8.211H5.53ZM2.966,5.961A2.98,2.98,0,1,1,5.932,2.967,2.991,2.991,0,0,1,2.966,5.961ZM24.7,24.7h-5.11V16.675c0-1.913-.039-4.367-2.663-4.367-2.663,0-3.071,2.079-3.071,4.229V24.7H8.738V8.211H13.65v2.25h.072A5.381,5.381,0,0,1,18.567,7.8c5.183,0,6.136,3.413,6.136,7.847V24.7Z","transform":"translate(12 11.999)","fill":"#fff","key":1})]);
}

Linkedin.defaultProps = {"id":"linkedin","viewBox":"0 0 48 48"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
